import ModalBase from "../../../../ui/modals/ModalBase";
import Button from "react-bootstrap/Button";
import React from "react";
import {Modal} from "react-bootstrap";

class FullProfileModalBase extends ModalBase{

    /**
     * Render the header component.
     * @returns {React.ReactNode} The header component of the modal.
     */
    renderHeader = () => {
        const {headerTitle, headerSubtitle} = this.props;

        return (
            <Modal.Title>
                <div className="title"> {headerTitle} </div>
                <div className="subtitle"> {headerSubtitle} </div>
            </Modal.Title>
        );
    };


    /**
     * Render the footer component.
     * @returns {React.ReactNode} The footer component of the modal.
     */
    renderFooter = () => {
    };


    renderDivider = () => <div className="divider"/>;
}
export default FullProfileModalBase;
